import { userManager } from "./oidc";

let silentRenewPromise = null;

export async function login(returnUrl) {
  const state = typeof returnUrl === "string" ? { returnUrl } : undefined;
  return userManager.signinRedirect({ state });
}

export async function logout() {
  return userManager.signoutRedirect();
}

export async function getAccessToken() {
  const user = await userManager.getUser();
  if (user && !user.expired && user.access_token) {
    return user.access_token;
  }

  // The access token can expire while the browser is on an external OAuth
  // provider. On return, renew it before sending the one-time callback to the
  // backend. Reuse one promise so concurrent API requests cannot start
  // competing silent-renew flows.
  try {
    if (!silentRenewPromise) {
      silentRenewPromise = userManager.signinSilent().finally(() => {
        silentRenewPromise = null;
      });
    }

    const renewedUser = await silentRenewPromise;
    if (!renewedUser || renewedUser.expired || !renewedUser.access_token) {
      return null;
    }
    return renewedUser.access_token;
  } catch {
    return null;
  }
}

// ✅ Prod: zentrale Auth-Quelle
export async function isAuthenticated() {
  const user = await userManager.getUser();
  return Boolean(user && !user.expired);
}



// ✅ Prod: Navbar/UI live updaten (login/logout/renew)
export function subscribeAuthChanges(onChange) {
  const notify = () => onChange?.();

  userManager.events.addUserLoaded(notify);
  userManager.events.addUserUnloaded(notify);
  userManager.events.addAccessTokenExpired(notify);
  userManager.events.addSilentRenewError(notify);
  userManager.events.addUserSignedOut?.(notify); // optional je nach oidc-client version

  return () => {
    userManager.events.removeUserLoaded(notify);
    userManager.events.removeUserUnloaded(notify);
    userManager.events.removeAccessTokenExpired(notify);
    userManager.events.removeSilentRenewError(notify);
    userManager.events.removeUserSignedOut?.(notify);
  };
}
